import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

// state
const state = {
  code: '',
  token: '',
  mainUser: '',
  entidad: '',
  canal: '',
  name: '',
  surname1: '',
  surname2: '',
  max_inactive_time: 0,
  customer_role: '',
  loading: false,
  error: '',
  errorDescription: '',
  isPasswordText: false,
  mqPhone: window.matchMedia('(max-width: 767px)'),
  nav: [],
  loadingOptionMenu: true
}

// getters
const getters = {
  getToken: state => state.token,
  getLoadingOptionMenu: state => state.loadingOptionMenu,
  getAppParams: state => ({
    token: state.token,
    mainUser: state.mainUser,
    entidad: state.entidad,
    customer_role: state.customer_role,
    canal: state.canal,
    maxInactiveTime: state.max_inactive_time,
    name: state.name,
    surname1: state.surname1,
    surname2: state.surname2
  }),

  getLoaderState () {
    return state.loading
  },
  getIsMobile () {
    return state.mqPhone.matches
  },
  getIsPasswordForm () {
    return state.isPasswordText
  },
  getErrorDescription () {
    return state.errorDescription
  },
  getNavPermissions: state => state.nav
}

// actions
const actions = {
  async login ({ commit, dispatch, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const hashPassword = utils.SHA256(data.password)
      state.mainUser = data.username
      state.canal = config.canal
      state.entidad = config.entidad
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: '',
            claveInicio: '',
            entidad: config.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: 0,
            retroceder: false,
            mainUser: data.username,
            securityToken: ''
          },
          eEntrada: {
            password: hashPassword
          }
        }
      })
      commit('LOGIN_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.login, body)

      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            commit('LOGIN_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            await dispatch('getOptionsMenu', data)
            commit('LOGIN_REQUEST_FINISHED', false)
            return response

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            commit('LOGIN_REQUEST_FINISHED', false)
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  },
  async getOptionsMenu ({ commit, rootState }, data) {
    commit('LOADING_OPTION_MENU', true)
    const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
    const config = rootState.appConfig.configFile
    let body = {}
    body = Object.assign({}, {
      runService: {
        opData: {
          avanzar: false,
          canal: storageAppData.canal,
          entidad: storageAppData.entidad,
          idioma: 'ES',
          indMasDatos: '',
          oficina: '0001',
          retroceder: false,
          mainUser: storageAppData.mainUser,
          securityToken: hashToken
        },
        eEntrada: ''
      }
    })

    const response = await HTTP.post(config.endpoints.optionsMenu, body)
    commit('LOADING_OPTION_MENU', false)
    sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
    commit('SET_NAV_PERMISSIONS', response.data.runServiceResponse.return)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'LOGIN_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'LOGIN_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'LOGIN_REQUEST_SUCCEED' (state, payload) {
    state.code = payload
    state.error = false
    state.errorDescription = ''
    state.token = payload.securityToken
    state.maxInactiveTime = payload.registros.max_inactive_time
    state.customer_role = payload.registros.customer_role
    state.name = payload.registros.nombre
    state.surname1 = payload.registros.apelli1
    state.surname2 = payload.registros.apelli2

    const paramsParsed = JSON.stringify({
      token: payload.securityToken,
      mainUser: state.mainUser,
      maxInactiveTime: payload.registros.max_inactive_time,
      customer_role: payload.registros.customer_role,
      canal: state.canal,
      entidad: state.entidad,
      name: state.name,
      surname1: state.surname1,
      surname2: state.surname2
    })
    const paramsComercio = JSON.stringify({
      comercio: ''
    })
    const paramsCadena = JSON.stringify({
      cadena: ''
    })
    const paramsMovimiento = JSON.stringify({
      movimiento: ''
    })
    const paramsPagina = JSON.stringify({
      pagina: 1
    })
    const paramsCadenaComercio = JSON.stringify({
      comercio: '',
      descomercio: '',
      numComercio: 1
    })
    sessionStorage.setItem('appParams', paramsParsed)
    sessionStorage.setItem('appComercio', paramsComercio)
    sessionStorage.setItem('appCadena', paramsCadena)
    sessionStorage.setItem('appMovimiento', paramsMovimiento)
    sessionStorage.setItem('appPagina', paramsPagina)
    sessionStorage.setItem('appCadenaComercio', paramsCadenaComercio)
  },
  'LOADING_OPTION_MENU' (state, payload) {
    state.loadingOptionMenu = payload
  },
  'SET_NAV_PERMISSIONS' (state, payload) {
    state.nav = payload.registros
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
